import { render, staticRenderFns } from "./GuarantorData.vue?vue&type=template&id=2c15db94&scoped=true&"
import script from "./GuarantorData.vue?vue&type=script&lang=js&"
export * from "./GuarantorData.vue?vue&type=script&lang=js&"
import style0 from "./GuarantorData.vue?vue&type=style&index=0&id=2c15db94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15db94",
  null
  
)

export default component.exports